import * as Effect from "effect-app/Effect"
import * as S from "effect-app/Schema"

const HexColor = S.String.pipe(S.check(S.isPattern(/^#[0-9A-Fa-f]{6}$/)))

/**
 * Per-face decor authoring value - a shared FORM schema (not a persisted model).
 * `image` maps a texture at real-world tile scale; `color` is a solid fill.
 * Distinct from the runtime `interface FaceDecor` in `faceDecor.ts` (the resolved
 * viewer contract). Defaults are intentionally generic - no playground coupling.
 * The two members are exported so their constructor defaults are unit-testable
 * and the future wiring can compose them.
 */
export const DXFImageDecor = S.TaggedStruct("image", {
  url: S.String.pipe(S.withConstructorDefault(Effect.succeed(""))),
  tileWidthMm: S.PositiveNumber.pipe(S.withConstructorDefault(Effect.succeed(600))),
  tileHeightMm: S.PositiveNumber.pipe(S.withConstructorDefault(Effect.succeed(600))),
  direction: S.Literals(["horizontal", "vertical"]).pipe(
    S.withConstructorDefault(Effect.succeed("horizontal" as const))
  )
})

export const DXFColorDecor = S.TaggedStruct("color", {
  color: HexColor.pipe(S.withConstructorDefault(Effect.succeed("#cccccc")))
})

export const DXFFaceDecor = S.Union([DXFImageDecor, DXFColorDecor])
